// React and Ant Design imports
import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Typography, Collapse, Divider, message, Modal } from 'antd';
import { CalendarOutlined, HomeOutlined, TeamOutlined, ManOutlined, ArrowLeftOutlined, WomanOutlined } from '@ant-design/icons';
import ReactFC from 'react-fusioncharts';
import FusionCharts from 'fusioncharts';
import FusionMaps from 'fusioncharts/fusioncharts.maps';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import ColombiaMap from 'fusioncharts/maps/fusioncharts.colombia';
import AntioquiaMap from 'fusioncharts/maps/fusioncharts.antioquia';
import AraucaMap from 'fusioncharts/maps/fusioncharts.arauca';
import AtlanticoMap from 'fusioncharts/maps/fusioncharts.atlantico';
import BolivarMap from 'fusioncharts/maps/fusioncharts.bolivar';
import BoyacaMap from 'fusioncharts/maps/fusioncharts.boyaca';
import CaldasMap from 'fusioncharts/maps/fusioncharts.caldas';
import CaquetaMap from 'fusioncharts/maps/fusioncharts.caqueta';
import CasanareMap from 'fusioncharts/maps/fusioncharts.casanare';
import CaucaMap from 'fusioncharts/maps/fusioncharts.cauca';
import CesarMap from 'fusioncharts/maps/fusioncharts.cesar';
import ChocoMap from 'fusioncharts/maps/fusioncharts.choco';
import CordobaMap from 'fusioncharts/maps/fusioncharts.cordoba';
import CundinamarcaMap from 'fusioncharts/maps/fusioncharts.cundinamarca';
import GuainiaMap from 'fusioncharts/maps/fusioncharts.guainia';
import GuaviareMap from 'fusioncharts/maps/fusioncharts.guaviare';
import GuajiraMap from 'fusioncharts/maps/fusioncharts.laguajira';
import HuilaMap from 'fusioncharts/maps/fusioncharts.huila';
import LaGuajiraMap from 'fusioncharts/maps/fusioncharts.laguajira';
import MagdalenaMap from 'fusioncharts/maps/fusioncharts.magdalena';
import MetaMap from 'fusioncharts/maps/fusioncharts.meta';
import NarinoMap from 'fusioncharts/maps/fusioncharts.narino';
import NorteDeSantanderMap from 'fusioncharts/maps/fusioncharts.nortedesantander';
import PutumayoMap from 'fusioncharts/maps/fusioncharts.putumayo';
import QuindioMap from 'fusioncharts/maps/fusioncharts.quindio';
import RisaraldaMap from 'fusioncharts/maps/fusioncharts.risaralda';
import SanAndresMap from 'fusioncharts/maps/fusioncharts.sanandresprovidenciaandsantacatalina';
import SantanderMap from 'fusioncharts/maps/fusioncharts.santander';
import SucreMap from 'fusioncharts/maps/fusioncharts.sucre';
import TolimaMap from 'fusioncharts/maps/fusioncharts.tolima';
import ValleDelCaucaMap from 'fusioncharts/maps/fusioncharts.valledelcauca';
import VaupesMap from 'fusioncharts/maps/fusioncharts.vaupes';
import VichadaMap from 'fusioncharts/maps/fusioncharts.vichada';
import AmazonasMap from 'fusioncharts/maps/fusioncharts.amazonas';
import axios from 'axios';
import config from '../../../config';
import { getMapColombia } from '../../../services/maps/getMapColombia';
import { getMapDepartment } from '../../../services/maps/getMapDepartment';
import dataDashboard from '../../../services/inicio/dashboard/dashboardService';
import dataDashboardDetalle from '../../../services/inicio/dashboard/detalleDashboardService';
import { faMapMarkedAlt, faLocationDot, faBuildingColumns  } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ProjectCard from "../DashboardDetalle/ProjectCard";
import OrganizationCard from "../DashboardDetalle/OrganizationCard";


import { ReactComponent as ColombiaIcon } from '../../../assets/colombia.svg';
import { ReactComponent as LocalizacionIcon } from '../../../assets/localizacion.svg';
import { ReactComponent as MundoIcon } from '../../../assets/mundo.svg';

import './Dashboard.css';


ReactFC.fcRoot(
  FusionCharts,
  FusionMaps,
  ColombiaMap,
  AntioquiaMap,
  AraucaMap,
  AtlanticoMap,
  BolivarMap,
  BoyacaMap,
  CaldasMap,
  CaquetaMap,
  CasanareMap,
  CaucaMap,
  CesarMap,
  ChocoMap,
  CordobaMap,
  CundinamarcaMap,
  GuainiaMap,
  GuaviareMap,
  GuajiraMap,
  HuilaMap,
  LaGuajiraMap,
  MagdalenaMap,
  MetaMap,
  NarinoMap,
  NorteDeSantanderMap,
  PutumayoMap,
  QuindioMap,
  RisaraldaMap,
  SanAndresMap,
  SantanderMap,
  SucreMap,
  TolimaMap,
  ValleDelCaucaMap,
  VaupesMap,
  AmazonasMap,
  VichadaMap,
  FusionTheme
);

const baseUrl = config.baseUrl;
const { Text } = Typography;

const customStyles = {
  primaryColor: '#338BC7',
  secondaryColor: '#BBC9DD',
  lightColor: '#DEE3EB',
  darkColor: '#02172F',
  accentColor: '#006FBE',
};

const Dashboard = () => {
  const [mapData, setMapData] = useState(null);
  const [error, setError] = useState(null);
  const [currentMapType, setCurrentMapType] = useState('maps/colombia');
  const [currentDepartmentId, setCurrentDepartmentId] = useState(null);
  const [idMap, setIdMap] = useState({});
  const [nameMap, setNameMap] = useState({});
  const [showBackButton, setShowBackButton] = useState(false);
  const [titleDepto, settitleDepto] = useState();
  const [dashboardDataDetalle, setDashboardDataDetalle] = useState(null);
  const [statCardProps, setStatCardProps] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalProyectoTipo, setModalProyectoTipo] = useState(null);
  const [modalOrganizacionTipo, setModalOrganizacionTipo] = useState(null);


  const [totales, setTotales] = useState({
    totalDepartamentos: 0, // Total number of departments
    totalMunicipios: 0,    // Total number of municipalities
    totalProyectos: 0,     // Total number of projects
    totalOrganizaciones: 0, // Total number of organizations
    totalHombres: 0,       // Total number of men
    totalMujeres: 0,       // Total number of women
    totalParticipantes: 0, // Total number of participants
    municipiosPorDepto: {}, // Data grouped by department
  });
  const handleBackButtonClick = () => {
    setMapData(null);
    setCurrentMapType('maps/colombia');
  };

  const [dashboardData, setDashboardData] = useState({
    subregiones: 0,
    departamentos: 0,
    municipios: 0,
    proyectos: {
      total: 0,
      fao: 0,
      organizaciones: 0,
      porAsignar: 0,
    },
    organizaciones: {
      total: 0,
      fao: 0,
      organizaciones: 0,
      porAsignar: 0,
    },
    personasProyectos: {
      total: 0,
      fao: { total: 0, hombres: 0, mujeres: 0 },
      organizaciones: { total: 0, hombres: 0, mujeres: 0 },
      porAsignar: { total: 0, hombres: 0, mujeres: 0 },
    },
    personasOrganizaciones: {
      total: 0,
      fao: { total: 0, hombres: 0, mujeres: 0 },
      organizaciones: { total: 0, hombres: 0, mujeres: 0 },
      porAsignar: { total: 0, hombres: 0, mujeres: 0 },
    },
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const data = await dataDashboard.getDataDahboard();
        setDashboardData(data);
      } catch (err) {
        console.error('Error al cargar los datos del dashboard:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);


  useEffect(() => {
    async function fetchData() {
      try {
        const response = await dataDashboardDetalle.getDataDahboardDetalle();
        setDashboardDataDetalle(response.data);
      } catch (err) {
        message.error("Error cargando los datos del dashboard.");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/dataColombia`);
        const data = response.data.dataColombia[0];
        const dataOrg = response.data.dataOrg[0];
        const dataCollapse = response.data.dataCollapse;
        const municipiosPorDepto = dataCollapse.reduce((acc, item) => {
          const listaMunicipios = item.listaMunicipios || "";
          const listaOrganizaciones = item.listaOrganizaciones || "";
          const listaProyectos = item.listaProyectos || "";
          acc[item.departamento] = {
            municipios: listaMunicipios
              .split('</li><li>')
              .map(m => m.replace(/<\/?li>/g, '').trim())
              .filter(m => m.length > 0),
            organizaciones: listaOrganizaciones
              .split('</li><li>')
              .map(org => org.replace(/<\/?li>/g, '').trim())
              .filter(org => org.length > 0),
            proyectos: listaProyectos
              .split('</li><li>')
              .map(proj => proj.replace(/<\/?li>/g, '').trim())
              .filter(proj => proj.length > 0)
          };
          return acc;
        }, {});
        setTotales({
          totalDepartamentos: data.total_deptos || 0,
          totalMunicipios: data.total_municipios || 0,
          totalProyectos: data.total_proyectos || 0,
          totalOrganizaciones: dataOrg.Total_Organizaciones || 0,
          totalHombres: dataOrg.Total_Hombres || 0,
          totalMujeres: dataOrg.Total_Mujeres || 0,
          totalParticipantes: dataOrg.Total_Participantes || 0,
          municipiosPorDepto: municipiosPorDepto,
        });
      } catch (error) {
        console.error('Error fetching map data:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let result;
        if (currentMapType === 'maps/colombia') {
          result = await getMapColombia();
          if (!result?.data?.data || !Array.isArray(result.data.data)) {
            setError('Datos del mapa inválidos');
            return;
          }
          const idMap = result.data.data.reduce((map, item) => {
            map[item.id] = item.idCodInterno;
            return map;
          }, {});
          setIdMap(idMap);

          const nameMap = result.data.data.reduce((map, item) => {
            map[item.id] = item.nameFusion;
            return map;
          }, {});
          setNameMap(nameMap);
          setCurrentDepartmentId(null);
          setShowBackButton(false);
          settitleDepto('');
        } else {
          result = await getMapDepartment(currentDepartmentId);
          if (!result?.data?.data || !Array.isArray(result.data.data)) {
            setError('Datos del mapa inválidos');
            return;
          }

          setShowBackButton(true);
        }

        setMapData({
          type: currentMapType,
          renderAt: 'map',
          width: '100%',
          height: '600',
          dataFormat: 'json',
          dataSource: {
            chart: {
              caption: 'UTF COL 160 - COL',
              subcaption: 'Proyectos por Departamento',
              theme: 'fusion',
              bgColor: '#dee3eb',
              showLabels: '0',
              showlegend: '0',
              borderColor: '#042956',
              borderThickness: '1',
              hoverBorderColor: '#4275af',
              hoverBorderThickness: '1',
              toolTipBorderColor: '#042956',
              toolTipBorderThickness: '1',
              entityFillHoverColor: '#fbc02d',
              entityBorderHoverColor: '#042956',
              toolTipPosition: 'bottom',
            },
            data: result.data.data,
          }
        });

      } catch (error) {
        console.error(error);
        setError('No se pudo cargar la información del mapa');
      }
    };

    fetchData();
  }, [currentMapType, currentDepartmentId]);

  if (error) {
    return <div>Error</div>;
  }
  if (loading) return <div>Cargando dashboard...</div>;
  if (error) return <div>Error al cargar el dashboard</div>;

  const handleEntityClick = (eventObj, dataObj) => {
    const departmentId = idMap[dataObj.id];
    const deptoName = nameMap[dataObj.id];
    if (departmentId && deptoName) {
      setCurrentDepartmentId(departmentId);
      const mapName = `maps/${deptoName}`;
      setCurrentMapType(mapName);
      settitleDepto(dataObj.label);
    }
  };

  const collapseItems = Object.keys(totales.municipiosPorDepto).map((departamento, index) => ({
    key: index,
    label: departamento,
    children: (
      <div>
        <div>
          <h4 className='titleCol'>Proyectos</h4>
          <ul style={{ textAlign: 'left' }}>
            {totales.municipiosPorDepto[departamento].proyectos.map((proyecto, idx) => (
              <li key={idx}>{proyecto}</li>
            ))}
          </ul>
        </div>
        <div style={{ marginTop: '16px' }}>
          <h4 className='titleCol'>Organizaciones</h4>
          <ul style={{ textAlign: 'left' }}>
            {totales.municipiosPorDepto[departamento].organizaciones.map((org, idx) => (
              <li key={idx}>{org}</li>
            ))}
          </ul>
        </div>
        <div style={{ marginTop: '16px' }}>
          <h4 className='titleCol'>Municipios</h4>
          <ul style={{ textAlign: 'left' }}>
            {totales.municipiosPorDepto[departamento].municipios.map((municipio, idx) => (
              <li key={idx}>{municipio}</li>
            ))}
          </ul>
        </div>
      </div>
    )
  }));

  const formatearNumero = (numero) => {
    return numero.toLocaleString('es-CO'); // es-CO usa punto como separador de miles
  };

  const chunkArray = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  const renderModalContent = (items, icon, color = "#338BC7") => {
    const groupedItems = chunkArray(items, 3);
    return (
      <div style={{
        maxHeight: "70vh",  // altura máxima visible
        overflowY: "auto",  // agrega scroll si se excede
        paddingRight: "8px", // evita que el scroll tape contenido
        paddingTop: "8px",
      }}>
        {groupedItems.map((group, rowIndex) => (
          <Row gutter={[16, 16]} key={rowIndex} style={{ paddingTop: "16px" }}>
            {group.map((item, colIndex) => (
              <Col span={8} key={colIndex}>
                <Card className="text-center" style={{ padding: "16px" }} hoverable>
                  <FontAwesomeIcon
                    icon={icon}
                    style={{ color, fontSize: "1.5rem", paddingTop: "16px" }}
                  />
                  <p className="text-base font-semibold mt-2">{item}</p>
                </Card>
              </Col>
            ))}
          </Row>
        ))}
      </div>
    );
  };

  const handleRedirectProyectos = (tipo) => {
    setModalProyectoTipo(tipo);
  }

  const handleRedirectOrganizaciones = (tipo) => {
    setModalOrganizacionTipo(tipo);
  }

  const handleRedirectLocalidades = (tipo) => {
    if (!dashboardDataDetalle) return;
    let data = [];
    let icon = null;
    let title = "";
    let subtitle = "";
    let color = "#338BC7";

    if (tipo === "Departamentos") {
      data = dashboardDataDetalle.departamentos || [];
      icon = faMapMarkedAlt;
      title = "Departamentos";
      subtitle = "Información detallada de departamentos";
    } else if (tipo === "Municipios") {
      data = dashboardDataDetalle.municipios || [];
      icon = faLocationDot;
      title = "Municipios";
      subtitle = "Información detallada de municipios";
    } else if (tipo === "Subregiones") {
      data = dashboardDataDetalle.subregiones || [];
      icon = faBuildingColumns ;
      title = "Subregiones";
      subtitle = "Información detallada de subregiones";
    }
    setStatCardProps({
      icon,
      title,
      value: data.length,
      color,
      subtitle,
      tooltipContent: data,
      modalContent: renderModalContent(data, icon, color),
    });

    setIsModalVisible(true);
  };

  return (
    <div>
      <div style={{ padding: '0px 30px' }}>
        <Row gutter={[16, 16]} style={{ padding: "0px", justifyContent: 'center', alignItems: 'center' }}>
          <Col xs={24} sm={6} className="d-flex justify-content-center" style={{ gap: '3rem' }}>
            <div
              className="d-flex flex-column align-items-center border rounded p-3"
              style={{ width: 'auto' }}
            >
              <div className="d-flex align-items-center mb-2">
                <ColombiaIcon style={{ fontSize: '1.9rem', color: '#338BC7' }} className="me-2" />
                <span className="h4 mb-0 textInidicadores">{dashboardData.departamentos}</span>
              </div>
              <span
                className="text-muted small etiquetaIndicador"
                onClick={() => handleRedirectLocalidades("Departamentos")}
                style={{ cursor: 'pointer' }}
              >
                Departamentos
              </span>
            </div>
            <div className="d-flex flex-column align-items-center border rounded p-3 mx-2" style={{ width: 'auto' }}>
              <div className="d-flex align-items-center mb-2">
                <LocalizacionIcon style={{ fontSize: '1.8rem', color: '#338bc7' }} className="me-2" />
                <span className="h4 mb-0 textInidicadores">{dashboardData.municipios}</span>
              </div>
              <span className="text-muted small etiquetaIndicador"
                onClick={() => handleRedirectLocalidades("Municipios")}
                style={{ cursor: 'pointer' }}
              >Municipios
              </span>
            </div>
            <div className="d-flex flex-column align-items-center border rounded p-3" style={{ width: 'auto' }}>
              <div className="d-flex align-items-center mb-2">
                <MundoIcon style={{ fontSize: '1.8rem', color: '#338bc7' }} className="me-2" />
                <span className="h4 mb-0 textInidicadores">{dashboardData.subregiones}</span>
              </div>
              <span className="text-muted small etiquetaIndicador"
                onClick={() => handleRedirectLocalidades("Subregiones")}
                style={{ cursor: 'pointer' }}>
                Subregiones
              </span>
            </div>
          </Col>
        </Row>
        <div className="row gx-4 gy-4 mt-0">
          <div className="col-12 col-md-6 d-flex">
            <div className="cardProyectos flex-fill  flex-column">
              <div className="custom-card-headerP d-flex justify-content-center align-items-center mb-3">
                <CalendarOutlined className="header-icon me-2" />
                <Text className="header-titleP">
                  Proyectos
                </Text>
              </div>
              <div className="row w-100 gx-3">
                <div className="col-12 col-md-6 d-flex flex-column align-items-center text-center mb-3 mb-md-0">
                  <div className="cardIndicadorProyecto mb-2"
                    hoverable
                    onClick={() => handleRedirectProyectos("Proyectos")}
                    style={{ cursor: 'pointer' }}
                  >
                    {formatearNumero(dashboardData.proyectos.total)}
                  </div>
                  <div className="h5 text-muted">Proyectos</div>
                </div>
                <div className="col-12 col-md-6 d-flex flex-column gap-2">
                  {[
                    ['FAO', dashboardData.proyectos.fao],
                    ['Organizaciones', dashboardData.proyectos.organizaciones],
                    ['Por asignar', dashboardData.proyectos.porAsignar],
                  ].map(([label, value]) => (
                    <div
                      key={label}
                      className="d-flex align-items-center"
                      onClick={() => handleRedirectProyectos(label === 'Organizaciones' ? 'ORGANIZACIÓN' : label.toUpperCase())}
                      style={{ cursor: 'pointer' }}
                    >
                      <span className="fw-bold valorProyectos ms-auto me-2">
                        {value}
                      </span>
                      <span className="texProyectos text-start flex-grow-1">
                        {label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex">
            <div className="cardProyectos flex-fill  flex-column">
              <div className="custom-card-headerO d-flex justify-content-center align-items-center mb-3">
                <HomeOutlined className="header-icon me-2" />
                <Text className="header-titleP"
                >
                  Organizaciones
                </Text>
              </div>
              <div className="row w-100 gx-3">
                <div className="col-12 col-md-6 d-flex flex-column align-items-center text-center mb-3 mb-md-0">
                  <div className="cardIndicadorOrganizaciones mb-2"
                    hoverable
                    onClick={() => handleRedirectOrganizaciones("Organizaciones")}
                    style={{ cursor: 'pointer' }}
                  >
                    {formatearNumero(dashboardData.organizaciones.total)}
                  </div>
                  <div className="h5 text-muted">Organizaciones</div>
                </div>
                <div className="col-12 col-md-6 d-flex flex-column gap-2">
                  {[
                    ['FAO', dashboardData.organizaciones.fao],
                    ['Organizaciones', dashboardData.organizaciones.organizaciones],
                    ['Por asignar', dashboardData.organizaciones.porAsignar],
                  ].map(([label, value]) => (
                    <div key={label} className="d-flex align-items-center"
                      onClick={() => handleRedirectOrganizaciones(label === 'Organizaciones' ? 'ORGANIZACIÓN' : label.toUpperCase())}
                      style={{ cursor: 'pointer' }}
                    >
                      <span className="fw-bold valorOrganizaciones ms-auto me-2">
                        {value}
                      </span>
                      <span className="texProyectos text-start flex-grow-1">
                        {label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row gx-4 gy-4 my-2">
          <div className="col-12 col-md-6 d-flex">
            <div className="card custom-cardP w-100">
              <div className="custom-card-headerP">
                <TeamOutlined className="header-icon" />
                <Text className="header-titleP">
                  Personas vinculadas a los proyectos
                </Text>
                <Text className="header-badgeP">
                  {formatearNumero(dashboardData.personasProyectos.total)}
                </Text>
              </div>
              <div className="card-body p-0 personas-table">
                {[
                  ['FAO', dashboardData.personasProyectos.fao],
                  ['Organizaciones', dashboardData.personasProyectos.organizaciones],
                  ['Por asignar', dashboardData.personasProyectos.porAsignar],
                ].map(([label, { total, mujeres, hombres }]) => (
                  <div key={label} className="personas-row d-flex align-items-center">
                    <span className="personas-label flex-fill">{label}</span>
                    <span className="personas-total-pill">{total}</span>
                    <div className="personas-gender-group d-flex gap-4">
                      <div className="gender-item">
                        <div className="d-flex justify-content-center mb-1">
                          <WomanOutlined className="gender-icon me-1" />
                          <small className="text-muted">Mujeres</small>
                        </div>
                        <span className="gender-text">{mujeres}</span>
                      </div>
                      <div className="vr bg-success mx-2 align-self-stretch" />
                      <div className="gender-item">
                        <div className="d-flex justify-content-center mb-1">
                          <ManOutlined className="gender-icon me-1" />
                          <small className="text-muted">Hombres</small>
                        </div>
                        <span className="gender-text">{hombres}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex">
            <div className="card custom-cardP w-100">
              <div className="custom-card-headerO">
                <HomeOutlined className="header-icon" />
                <Text className="header-titleP">
                  Personas vinculadas a Organizaciones
                </Text>
                <Text className="header-badgeP">
                  {formatearNumero(dashboardData.personasOrganizaciones.total)}
                </Text>
              </div>
              <div className="card-body p-0 personas-table">
                {[
                  ['FAO', dashboardData.personasOrganizaciones.fao],
                  ['Organizaciones', dashboardData.personasOrganizaciones.organizaciones],
                  ['Por asignar', dashboardData.personasOrganizaciones.porAsignar],
                ].map(([label, { total, mujeres, hombres }]) => (
                  <div key={label} className="personas-row d-flex align-items-center">
                    <span className="personas-label flex-fill">{label}</span>
                    <span className="personas-total-pill-O">{total}</span>
                    <div className="personas-gender-group d-flex align-items-center gap-4">
                      <div className="gender-item">
                        <div className="d-flex align-items-center justify-content-center mb-1">
                          <WomanOutlined className="gender-icon-O" />
                          <small className="gender-label ms-1 text-muted">
                            Mujeres
                          </small>
                        </div>
                        <span className="gender-text">
                          {mujeres}
                        </span>
                      </div>
                      <div className="vr bg-success mx-2 align-self-stretch" />
                      <div className="gender-item">
                        <div className="d-flex align-items-center justify-content-center mb-1">
                          <ManOutlined className="gender-icon-O" />
                          <small className="gender-label ms-1 text-muted">
                            Hombres
                          </small>
                        </div>
                        <span className="gender-text">
                          {hombres}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Divider />
        <Row gutter={[24, 24]} align="top" style={{ marginTop: 30 }}>
          <Col xs={24} md={12} style={{ height: '100%' }}>
            <Card
              style={{
                borderColor: customStyles.secondaryColor,
                height: '100%'
              }}
              styles={{ body: { padding: 0 } }}
            >
              <Collapse
                style={{ background: '#4375af3b', textAlign: 'left' }}
                items={collapseItems}
                expandIconPosition="start"
              />
            </Card>
          </Col>
          <Col xs={24} md={12} style={{ height: '750px', width: '100%' }}>
            <Card
              hoverable
              style={{
                borderColor: customStyles.secondaryColor,
                ...customStyles.cardHover,
                height: '100%',
                width: '100%',
              }}
              styles={{
                body: {
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'stretch',
                  justifyContent: 'center',
                  height: '100%',
                  padding: 0,
                }
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  overflowY: 'auto',
                  padding: '0 16px',
                  backgroundColor: '#dee3eb',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {showBackButton && (
                  <button onClick={handleBackButtonClick} style={{
                    alignSelf: 'flex-start',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginTop: '16px',
                    backgroundColor: '#fff',
                    color: '#042956',
                    border: '1px solid #042956',
                    borderRadius: '8px',
                    padding: '6px 12px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                  }}>
                    <ArrowLeftOutlined /> Volver
                  </button>
                )}
                <div id="map" style={{
                  width: '100%',
                  height: '600px',
                  minHeight: '600px',
                  maxHeight: '600px',
                  minWidth: '100%',
                  maxWidth: '100%',
                  overflow: 'hidden',
                  flexGrow: 0,
                  position: 'relative'
                }}>
                  <div className="header-container-depto">
                    {titleDepto && <h3 className="header-title">Departamento | {titleDepto}</h3>}
                  </div>
                  {mapData?.dataSource?.data ? (
                    <ReactFC key={`${currentMapType}-${currentDepartmentId}`} {...mapData} fcEvent-entityClick={handleEntityClick} />
                  ) : (
                    <p>Cargando...</p>
                  )}
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={800}
        title={
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <FontAwesomeIcon
                icon={statCardProps?.icon}
                style={{ color: '#338BC7', fontSize: '1.2rem' }}
              />
              <span style={{ fontSize: '1.1rem', fontWeight: 600 }}>
                {statCardProps?.title}
              </span>
            </div>
            <div style={{ fontSize: '0.9rem', color: '#888', marginTop: 4 }}>
              {statCardProps?.subtitle}
            </div>
          </div>
        }
      >
        {statCardProps?.modalContent}
      </Modal>
      {dashboardDataDetalle && (
        <>{modalProyectoTipo && (
          <ProjectCard
            title="Proyectos"
            total={dashboardData.proyectos.total}
            breakdown={[
              {
                label: "FAO",
                value: dashboardData.proyectos.fao.length,
                type: "FAO",
                color: "from-emerald-500 to-emerald-600",
              },
              {
                label: "Organizaciones",
                value: dashboardData.proyectos.organizaciones.length,
                type: "ORGANIZACIÓN",
                color: "from-blue-500 to-blue-600",
              },
              {
                label: "Por asignar",
                value: dashboardData.proyectos.porAsignar.length,
                type: "POR ASIGNAR",
                color: "from-amber-500 to-amber-600",
              },
            ]}
            color="bg-slate-700"
            dashboardData={dashboardDataDetalle}
            modalProyectoTipo={modalProyectoTipo}
            setModalProyectoTipo={setModalProyectoTipo}
          />)}
          {modalOrganizacionTipo && (
          <OrganizationCard
            title="Organizaciones"
            total={dashboardData.organizaciones.total}
            breakdown={[
              {
                label: "FAO",
                value: dashboardData.organizaciones.fao.length,
                type: "FAO",
                color: "from-emerald-500 to-emerald-600",
              },
              {
                label: "Organizaciones",
                value: dashboardData.organizaciones.organizaciones.length,
                type: "ORGANIZACIÓN",
                color: "from-blue-500 to-blue-600",
              },
              {
                label: "Por asignar",
                value: dashboardData.organizaciones.porAsignar.length,
                type: "POR ASIGNAR",
                color: "from-amber-500 to-amber-600",
              },
            ]}
            color="bg-slate-700"
            dashboardData={dashboardDataDetalle}
            modalOrganizacionTipo={modalOrganizacionTipo}
            setModalOrganizacionTipo={setModalOrganizacionTipo}
          />)}
        </>
      )}
    </div>
  );
};

export default Dashboard;